import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import CohortAssortmentCreationComponent from "./component";
import { useParams, useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';

const CohortAssortmentListDetailsContainer = (props) => {
  const navigate = useNavigate();
  const { reference_id, assortmentId } = useParams();
  const [showEndRuleModal, setShowEndRuleModal] = useState(false);
  const [selectedRuleToEnd, setSelectedRuleToEnd] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [assortmentWarehouseMetaDataDetails, setAssortmentWarehouseMetaDataDetails] = useState(null);
  const [assortmentWarehouseMetaDataDetailsList, setAssortmentWarehouseMetaDataDetailsList] = useState([]);
  const [assortmentWarehouseMetaDataRuleDetailsList, setAssortmentWarehouseMetaDataRuleDetailsList] = useState([]);
  const [assortmentCohortMachinesDetailsList, setAssortmentCohortMachinesDetailsList] = useState();
  const [activeTab, setActiveTab] = useState("assortments");
  const [selectedHardwareType, setSelectedHardwareType] = useState(null);

  // Initialize all data loading functions
  const handleAssortmentWarehouseDetails = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/cohort/${reference_id}/metadata`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataDetails(response || null);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentWarehouseDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/cohort/${reference_id}/all`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataDetailsList(response || []);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentWarehouseRuleDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/cohort/${reference_id}/all`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataRuleDetailsList(response || []);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  }, 300);

  const handleAssortmentCohortMachinesDetailsList = debounce(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/cohort/${reference_id}/machine/details`,
      "GET",
      undefined,
      (response) => {
        const machinesData = response || [];
        setAssortmentCohortMachinesDetailsList(machinesData);
        console.log("machine data", machinesData)
        // Set the first hardware type as selected by default if available
        if (machinesData.length > 0) {
          setSelectedHardwareType(machinesData[0].hardwareTypeId);
        } else {
          setSelectedHardwareType(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setAssortmentCohortMachinesDetailsList([]);
        setSelectedHardwareType(null);
        setLoading(false);
      }
    );
  }, 300);

  // Initial data load
  useEffect(() => {
    handleAssortmentWarehouseDetails();
    handleAssortmentWarehouseDetailsList();
    handleAssortmentCohortMachinesDetailsList();
  }, [reference_id]);

  // Load rules when tab changes
  useEffect(() => {
    if (activeTab === "rules" && assortmentWarehouseMetaDataRuleDetailsList.length === 0) {
      handleAssortmentWarehouseRuleDetailsList();
    }
  }, [activeTab]);

  // Modal handlers
  const handleOpenEndRuleModal = (ruleId) => {
    setSelectedRuleToEnd(ruleId);
    setShowEndRuleModal(true);
  };

  const handleCloseEndRuleModal = () => {
    setShowEndRuleModal(false);
    setSelectedRuleToEnd(null);
    setEndDate("");
  };

  const handleEndRuleConfirm = () => {
    if (!endDate) {
      console.error("End date is required");
      return;
    }

    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/inactive/${selectedRuleToEnd}/${endDate}`,
      "PUT",
      undefined,
      (response) => {
        console.log("Rule ended successfully");
        handleCloseEndRuleModal();
        handleAssortmentWarehouseRuleDetailsList();
      },
      (err) => {
        console.error("API Error:", err);
        setLoading(false);
      }
    );
  };

  // Navigation handlers
  const handleAssortmentDetails = (assortmentId) => {
    navigate(`/home/assortment/assortmentdetails/${assortmentId}`);
  };

  const handleCreateNewAssortment = () => {
    navigate(`/home/assortment/newassortmentcohortcreation/${reference_id}`);
  };

  const handleCreateNewRule = () => {
    navigate(`/home/assortment/newcohortassortmentrulecreation/${reference_id}`);
  };

  const handleRuleUpdate = (ruleId) => {
    navigate(`/home/assortment/cohort/rule/edit/${ruleId}`);
  };

  const handleCreateNewMachine = () => {
    navigate("/home/assortment/newmachinecreation");
  };

  return (
    <CohortAssortmentCreationComponent
      loading={loading}
      assortmentWarehouseMetaDataDetails={assortmentWarehouseMetaDataDetails}
      assortmentWarehouseMetaDataDetailsList={assortmentWarehouseMetaDataDetailsList}
      assortmentWarehouseMetaDataRuleDetailsList={assortmentWarehouseMetaDataRuleDetailsList}
      assortmentCohortMachinesDetailsList={assortmentCohortMachinesDetailsList}
      selectedHardwareType={selectedHardwareType}
      setSelectedHardwareType={setSelectedHardwareType}
      showEndRuleModal={showEndRuleModal}
      endDate={endDate}
      onEndDateChange={setEndDate}
      onCloseEndRuleModal={handleCloseEndRuleModal}
      onEndRuleConfirm={handleEndRuleConfirm}
      onAssortmentDetails={handleAssortmentDetails}
      onAssortmentRuleRemove={handleOpenEndRuleModal}
      onCreateNewAssortment={handleCreateNewAssortment}
      onCreateNewRule={handleCreateNewRule}
      onCreateNewMachine={handleCreateNewMachine}
      handleRuleUpdate={handleRuleUpdate}
      onTabChange={setActiveTab}
    />
  );
};

function mapStateToProps(props) {
  return { props };
}

export default connect(mapStateToProps, { getDataFromAPI })(CohortAssortmentListDetailsContainer);